import { VerifyCodeStepFormFieldsEnum, yupLanding } from "@ryde/utils-landings";

const VERIFICATION_CODE_LENGTH = 6;

export const yupVerifyCodeLandingValidationSchema = {
  [VerifyCodeStepFormFieldsEnum.VerificationCode]: yupLanding
    .string()
    .required()
    .length(VERIFICATION_CODE_LENGTH),
};
